export const HEADER_TOP_PADDING = '0px';
export const IMAGE_BACKGROUND_COLOR = '#f4f1ef';
export const IMAGE_WIDTH = '13.75rem';
